import type { FileApi } from '@mimir/common/upload/fileApi';

// Old Electron (<32.0.0) had a path property on the File object, but newer versions do not.
interface OldOrNewFile extends File {
  path?: string;
}
export const ensurePathForLocalCopy = (file: OldOrNewFile): FileApi => {
  if (!window.mimirElectron || file.path) {
    return file;
  }

  file.path = window.mimirElectron.getPathForFile(file);
  return file;
};
